import {app} from '../../app';
import {ISessionService} from "../../services/SessionService";

export class RadioQuestionPreviewComponent implements ng.IComponentController {

    protected sessionService:ISessionService;

    question:IQuestion;
    value:string;

    choices:string[] = [];
    ids:string[]     = [];

    static $inject = ['SessionService'];

    constructor(sessionService:ISessionService) {
        this.sessionService = sessionService;
    }

    public $onInit = () => {
        this.setup();
    };

    setup() {
        let choices = this.question.meta.choices;
        if (choices) {
            this.choices = choices;
        }

        let defaultValue = this.question.meta.default;
        if (defaultValue) {
            this.value = defaultValue;
        }

        let answer = this.sessionService.getAnswer(this.question.id);
        if (answer && answer.values.length > 0) {
            let choice = answer.values[0].choice;
            if (choice <= this.choices.length) {
                this.value = this.choices[choice];
            }
        }
    }

}

app.component('radioQuestionPreview', {
    templateUrl : 'templates/components/questionPreviews/radioQuestionPreview.html',
    controller  : RadioQuestionPreviewComponent,
    controllerAs: 'radioQuestionPreview',
    bindings    : {
        question: '<',
    }
});